class CheckoutForm {
  constructor(element, options) {
    this._options = { ...CheckoutForm.options, ...options };
    this._element = element;
    this._initFields = this._initFields.bind(this);
    this._setTextarea = this._setTextarea.bind(this);
    this._textareaEvents = ['change', 'keyup', 'paste'];
    this._init();
  }

  _init() {
    this._cacheSelectors();
    this._initFields();
  }

  _cacheSelectors() {
    this._fields = [...this._element.querySelectorAll('input.FormTextbox__Input, select')];
    this._textarea = [...this._element.querySelectorAll('textarea')];
    this._selects = [...this._element.querySelectorAll('select')];
    // this._numbers = [...this._element.querySelectorAll('[type="number"]')]
    // this._checkboxes = [
    //   ...this._element.querySelectorAll('input[type="checkbox"]')
    // ]
    // this._radios = [...this._element.querySelectorAll('input[type="radio"]')]
  }

  _setTextarea = (textarea) => {
    const compStyles = window.getComputedStyle(textarea);
    const lineheight = parseInt(compStyles.getPropertyValue('line-height'), 10);
    const paddingtop = parseInt(compStyles.getPropertyValue('padding-top'), 10);
    const paddingbottom = parseInt(compStyles.getPropertyValue('padding-bottom'), 10);
    const lines = textarea.value.split('\n').length;
    const height = lines * lineheight + paddingtop + paddingbottom;
    textarea.style.height = `${height}px`;
  };

  _setSelect = (select) => {
    if (select.selectedIndex) {
      select.setAttribute('data-selected', true);
    } else {
      select.setAttribute('data-selected', false);
    }
  };

  _initFields() {
    this._textarea.forEach((textarea) => {
      this._setTextarea(textarea);
      this._textareaEvents.forEach((event) => {
        textarea.addEventListener(
          event,
          () => {
            this._setTextarea(textarea);
          },
          true
        );
      });
    });

    this._selects.forEach((select) => {
      this._setSelect(select);
      select.addEventListener(
        'change',
        () => {
          this._setSelect(select);
        },
        true
      );
    });
  }
}

export default CheckoutForm;
